import React from 'react';

import { SettingLevel } from 'src/generated/mloop-graphql';

import { SyncedFromOrgSettings } from 'src/components/SyncedFromOrgSettings';

import { OrgSettingsSource } from 'src/constants/routes';

type Props = {
  source: OrgSettingsSource;
  level?: SettingLevel;
};

// This component is used to wrap the SyncedFromOrgSettings component to be used in the SettingsRow component
// this is to show the label of the are synced from org settings
export const SyncedFromOrgSettingsWrapper: React.FC<Props> = ({ source, level }) => {
  if (level !== SettingLevel.Org) {
    return null;
  }

  return <SyncedFromOrgSettings source={source} />;
};
